import {SListTabs} from "shj-components";
import {useSetState} from "ahooks";
import ProductManage from "@/pages/productManage/index.tsx";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const SPUManageTabList = () => {
  const [search] = useSearchParams()
  const activeTabKey = search.get('activeTabKey')
  const [state, setState] = useSetState({
    activeKey: activeTabKey || 'all',
  })

  useEffect(() => {
    activeTabKey && changeActiveKey(activeTabKey)
  }, [activeTabKey]);

  const changeActiveKey = (key) => {
    setState({ activeKey: key })
  }

  const data = [ {key: 'all', label: '全量产品', children: <ProductManage isShowGuide={false} activeTabKey={state.activeKey}/>},
    {key: 'case', label: '方案库', children: <ProductManage type={'SOLUTION_LIBRARY'} activeTabKey={state.activeKey}/>},
    {key: 'single', label: '零售库', children: <ProductManage isShowGuide={false} type={'RETAIL_LIBRARY'} activeTabKey={state.activeKey}/>},]

  return <>
    <SListTabs activeKey={state.activeKey} onChange={changeActiveKey} auth={false} items={data} />
  </>
}

export default SPUManageTabList;